import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTodoViewComponent } from './fi-todo-view.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiTodoListSectionItemModule } from '../fi-todo-list-section-item/fi-todo-list-section-item.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        FiAttachmentsModule,
        FiAppTextSharedModule,
        FiMatIconCheckboxMenuModule, 
        FiBindHtmlCompileModule,
        FiTodoListSectionItemModule,
    ],
    declarations: [
        FiTodoViewComponent,
    ],
})
export class FiTodoViewModule { }